var TotalJobsGroup = TotalJobsGroup || {};
TotalJobsGroup.Header = TotalJobsGroup.Header || {};

TotalJobsGroup.Header.AutoCompleteService = TotalJobsGroup.Header.AutoCompleteService || (function ($) {
    "use strict";

    function search(request) {

        // The legacy web services used for autocomplete need JSON as a string, not a JSON object
        var jsonData = JSON.stringify(request.data);

        $.ajax({
            type: "POST",
            url: request.url,
            contentType: "application/json; charset=utf-8",
            data: jsonData,
            success: request.successCallback,
            error: function () {
                return "Sorry, an error occurred :(";
            }
        });
    }

    return {
        search: search
    };
})(jQuery);